import { Admin } from 'api/admin/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<Admin>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminUsersReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminUsers.request.type]: actionsHandlers.handleGetPaginatedManyRequest,
  [actions.getAdminUsers.success.type]: actionsHandlers.handleGetPaginatedManySuccess,
  [actions.getAdminUsers.failure.type]: actionsHandlers.handleGetPaginatedManyFailure,
  [actions.getAdminUsers.reset.type]: actionsHandlers.handleGetPaginatedManyReset,
});

export default adminUsersReducer;
